import axios from "axios";
import { getUnitApiBaseFour,SUB_URL_BIN } from "./BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) throw new Error("unit_code missing");
  return unitCode;
};

const BinMovementService = {
  getBinMovement: async (binId) => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_BIN.get_bin_movement}/${binId}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching bin movement:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message || "Failed to fetch bin movement",
        data: [],
        total_records: 0,
      };
    }
  },
};

export default BinMovementService;